import { Component } from '@verndale/core';

import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import '../../scss/modules/full-width-image-carousel.scss';
import 'swiper/css';

class FullWidthCarousel extends Component {
  private swiper: Swiper | null = null;

  constructor(el: HTMLElement) {
    super(el);

    if (!this.swiper) {
      this.initSwiper();
    }
  }

  setupDefaults() {
    this.dom = {
      swiper: this.el.querySelector<HTMLDivElement>('.swiper'),
      slides: this.el.querySelectorAll<HTMLDivElement>('.swiper-slide'),
      pagination: this.el.querySelector<HTMLDivElement>('.swiper-pagination'),
      next: this.el.querySelector<HTMLDivElement>('.swiper-button-next'),
      prev: this.el.querySelector<HTMLDivElement>('.swiper-button-prev')
    };
  }

  initSwiper() {
    this.el?.classList.remove('fw-carousel__no-carousel');
    if ((this.dom.slides as NodeList).length <= 1) {
      this.el?.classList.add('fw-carousel__no-carousel');
      return;
    }
    if (!this.swiper) {
      this.swiper = new Swiper(this.dom.swiper as HTMLElement, {
        modules: [Navigation, Pagination, A11y, Keyboard],
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        pagination: {
          el: this.dom.pagination as HTMLElement,
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => {
            return `<span class="swiper-pagination-current">${currentClass}</span>/<span class="swiper-pagination-total">${totalClass}</span>`;
          }
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        navigation: {
          nextEl: this.dom.next as HTMLElement,
          prevEl: this.dom.prev as HTMLElement
        }
      });
    }
  }
}

export default FullWidthCarousel;
